import Vue from 'vue'
import Router from 'vue-router'
import http from '@/utils/request'
import { isURL } from '@/utils/validate'

Vue.use(Router)

// 概览菜单(前端固定注入, 后端无需配置)
const overviewMenu = {
  id: 'overview-management',
  name: '概览',
  icon: 'icon-dashboard',
  children: [
    { id: 'overview-dashboard', name: '数据概览', url: 'dashboard/dashboard', icon: 'icon-barchart' }
  ]
}

// 内容管理菜单(前端固定注入, 后端无需配置)
const contentMenu = {
  id: 'content-management',
  name: '内容管理',
  icon: 'icon-folder',
  children: [
    { id: 'content-video', name: '视频管理', url: 'content/video', icon: 'icon-play-square' },
    // 分集功能暂时下线，恢复时同步放开视频管理页操作列的「分集」按钮
    // { id: 'content-movies-info', name: '视频分集', url: 'moviesinfo/moviesinfo', icon: 'icon-video' },
    { id: 'content-category-tag', name: '分类标签', url: 'content/category-tag', icon: 'icon-tags' },
    { id: 'content-notice', name: '公告管理', url: 'content/notice', icon: 'icon-notification' }
  ]
}

// 用户中心菜单(前端固定注入, 后端无需配置)
const userCenterMenu = {
  id: 'user-center',
  name: '用户中心',
  icon: 'icon-team',
  children: [
    { id: 'user-center-list', name: '用户列表', url: 'usercenter/user-list', icon: 'icon-user' },
    { id: 'user-center-vip', name: '会员管理', url: 'usercenter/vip', icon: 'icon-crown' },
    { id: 'user-center-daily-login', name: '每日登录统计', url: 'usercenter/daily-login', icon: 'icon-barchart' }
  ]
}

// 交易中心菜单(前端固定注入, 后端无需配置)
const tradeMenu = {
  id: 'trade-center',
  name: '交易中心',
  icon: 'icon-transaction',
  children: [
    { id: 'trade-order-list', name: '订单列表', url: 'trade/order-list', icon: 'icon-wallet' },
    { id: 'trade-payment-channel', name: '支付通道', url: 'trade/payment-channel', icon: 'icon-creditcard' },
    { id: 'trade-package-price', name: '套餐定价', url: 'trade/package-price', icon: 'icon-shopping' }
  ]
}

// 代理管理菜单(前端固定注入, 后端无需配置)
const agentMenu = {
  id: 'agent-management',
  name: '代理管理',
  icon: 'icon-team',
  children: [
    { id: 'agent-users', name: '代理用户', url: 'agent/users', icon: 'icon-user' },
    { id: 'agent-lines', name: '代理线路', url: 'agent/lines', icon: 'icon-link' },
    { id: 'agent-commissions', name: '返佣流水', url: 'agent/commissions', icon: 'icon-file' },
    { id: 'agent-withdraw-applies', name: '提现申请', url: 'agent/withdraw-applies', icon: 'icon-audit' },
    { id: 'agent-withdraw-records', name: '提现流水', url: 'agent/withdraw-records', icon: 'icon-file' },
    { id: 'agent-global-config', name: '全局设置', url: 'agent/global-config', icon: 'icon-setting' },
    { id: 'agent-receipts', name: '收款列表', url: 'agent/receipts', icon: 'icon-file' },
    { id: 'agent-exchange-rate', name: '汇率设置', url: 'agent/exchange-rate', icon: 'icon-setting' }
  ]
}

// 运营配置菜单(前端固定注入, 后端无需配置)
const operationMenu = {
  id: 'operation-config',
  name: '运营配置',
  icon: 'icon-setting',
  children: [
    { id: 'operation-site-setting', name: '站点设置', url: 'operation/site-setting', icon: 'icon-control' },
    { id: 'operation-cdn-domain', name: 'CDN域名', url: 'operation/cdn-domain', icon: 'icon-link' }
  ]
}

// 系统菜单(前端固定注入, 后端无需配置)
const systemMenu = {
  id: 'system-center',
  name: '系统',
  icon: 'icon-appstore',
  children: [
    { id: 'system-admin', name: '管理员', url: 'system/admin', icon: 'icon-user' },
    { id: 'system-operation-log', name: '操作日志', url: 'system/operation-log', icon: 'icon-filedone' }
  ]
}

/**
 * 本项目的菜单完全由前端定义。
 * 后端 /sys/menu/nav 下发的菜单对应的是旧后台的业务模块，本项目没有这些页面，
 * 展示出来点击只会 404，因此不再使用其返回值，只按下面的顺序渲染。
 */
const localMenuList = [
  overviewMenu,
  contentMenu,
  userCenterMenu,
  tradeMenu,
  agentMenu,
  operationMenu,
  systemMenu
]

// 页面路由(独立页面)
export const pageRoutes = [
  {
    path: '/404',
    component: () => import('@/views/pages/404'),
    name: '404',
    meta: { title: '404未找到' },
    beforeEnter(to, from, next) {
      // 拦截处理特殊业务场景
      // 如果, 重定向路由包含__双下划线, 为临时添加路由
      if (/__.*/.test(to.redirectedFrom)) {
        return next(to.redirectedFrom.replace(/__.*/, ''))
      }
      next()
    }
  },
  { path: '/login', component: () => import('@/views/pages/login'), name: 'login', meta: { title: '登录' } },

]

// 模块路由(基于主入口布局页面)
export const moduleRoutes = {
  path: '/',
  component: () => import('@/views/main'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: '主入口布局' },
  children: [
    { path: '/home', component: () => import('@/views/modules/home'), name: 'home', meta: { title: '首页', isTab: true } }
  ]
}

export function addDynamicRoute(routeParams, router) {
  // 组装路由名称, 并判断是否已添加, 如是: 则直接跳转
  var routeName = routeParams.routeName
  var dynamicRoute = window.SITE_CONFIG['dynamicRoutes'].filter(item => item.name === routeName)[0]

  if (dynamicRoute) {

    return router.push({ name: routeName, params: routeParams.params })
  }
  // 否则: 添加并全局变量保存, 再跳转
  dynamicRoute = {
    path: routeName,
    component: () => import(`@/views/modules/${routeParams.path}`).catch(err => {
      console.error(`Failed to load component: @/views/modules/${routeParams.path}`, err)
      return import('@/views/pages/404')
    }),
    name: routeName,
    meta: {
      ...window.SITE_CONFIG['contentTabDefault'],
      menuId: routeParams.menuId,
      title: `${routeParams.title}`
    }
  }
  router.addRoutes([
    {
      ...moduleRoutes,
      name: `main-dynamic__${dynamicRoute.name}`,
      children: [dynamicRoute]
    }
  ])
  window.SITE_CONFIG['dynamicRoutes'].push(dynamicRoute)
  router.push({ name: dynamicRoute.name, params: routeParams.params })
}

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: pageRoutes.concat(moduleRoutes)
})

router.beforeEach((to, from, next) => {
  // 添加动态(菜单)路由
  // 已添加或者当前路由为页面路由, 可直接访问
  if (window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] || fnCurrentRouteIsPageRoute(to, pageRoutes)) {
    return next()
  }


  // 获取字典列表, 添加并全局变量保存
  http.get('/sys/dict/type/all').then(({ data: res }) => {
    if (res.code !== 0) {
      return
    }
    window.SITE_CONFIG['dictList'] = res.data
  }).catch(() => { })
  // 仍然请求菜单接口, 用于校验登录态(未登录/token失效时跳登录), 但菜单本身只用前端定义的
  http.get('/sys/menu/nav').then(({ data: res }) => {
    if (res.code !== 0) {
      Vue.prototype.$message.error(res.msg)
      return next({ name: 'login' })
    }
    window.SITE_CONFIG['menuList'] = localMenuList
    fnAddDynamicMenuRoutes(window.SITE_CONFIG['menuList'])
    next({ ...to, replace: true })
  }).catch(() => {
    next({ name: 'login' })
  })
})

/**
 * 判断当前路由是否为页面路由
 * @param {*} route 当前路由
 * @param {*} pageRoutes 页面路由
 */
function fnCurrentRouteIsPageRoute(route, pageRoutes = []) {
  var temp = []
  for (var i = 0; i < pageRoutes.length; i++) {
    if (route.path === pageRoutes[i].path) {
      return true
    }
    if (pageRoutes[i].children && pageRoutes[i].children.length >= 1) {
      temp = temp.concat(pageRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteIsPageRoute(route, temp) : false
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {

  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
      continue
    }
    // 组装路由
    var route = {
      path: '',
      component: null,
      name: '',
      meta: {
        ...window.SITE_CONFIG['contentTabDefault'],
        menuId: menuList[i].id,
        title: menuList[i].name
      }
    }
    // eslint-disable-next-line
    let URL = (menuList[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      route['path'] = route['name'] = `i-${menuList[i].id}`
      route['meta']['iframeURL'] = URL
    } else {
      const originalURL = URL
      URL = URL.replace(/^\//, '').replace(/_/g, '-')
      console.log(`Processing route: ${menuList[i].name}, original URL: ${originalURL}, processed URL: ${URL}`)

      // 处理重复路径的情况，如 novel/novel -> novel/novel
      let componentPath = URL
      const parts = URL.split('/')
      if (parts.length === 2 && parts[0] === parts[1]) {
        // 如果是 novel/novel 这种格式，直接使用
        componentPath = URL
      }

      route['path'] = route['name'] = URL.replace(/\//g, '-')
      route['component'] = () => import(`@/views/modules/${componentPath}.vue`).catch(err => {
        console.error(`Failed to load component: @/views/modules/${componentPath}.vue`, err)
        return import('@/views/pages/404')
      })
    }
    routes.push(route)
  }
  if (temp.length >= 1) {
    return fnAddDynamicMenuRoutes(temp, routes)
  }

  // 添加路由
  router.addRoutes([
    {
      ...moduleRoutes,
      name: 'main-dynamic-menu',
      children: routes
    },
    { path: '*', redirect: { name: '404' } }
  ])
  window.SITE_CONFIG['dynamicMenuRoutes'] = routes
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = true
}

export default router
